module.exports = __webpack_public_path__ + "static/media/current_user_avatar_fpo.3ee673dd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/current_user_avatar_fpo.png
 ** module id = 290
 ** module chunks = 0
 **/